<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :queryOnLoad="true" :confKey="confKey" :configAuto="configAuto" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="configAuto"
                          :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                          :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler"
                          :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servicerApi from '../../api/servicer'

    import SwbQuerySortArea from '../query/QuerySortArea';
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbQuerySortArea);
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-servicer-xngineer-list-for-select',
        desc: '服务工程师-选择',
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                confKey: 'swb-servicer-xngineer-list',
                configAuto: true,
                tableHeight: '500px',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
//            let thisEl = $(this.$el);
//            $(this.$el).addClass("overflow-hidden");
//            //
//            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
//            domSizeWatcher.setBaseEl(thisEl);
//            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
//                //根据新主元素的内容大小，调整表格高度
//                // self.tableHeight = height;
//            });
//            //domSizeWatcher.setHrEls();
////            console.log("domHeight： " + self.domHeight);
//            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"]'));
//            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'name1': function (row, colName, colValue, rowIndex, colConf) {
                        let namecontent = '<span>' + row.name + '</span>  ';
                        //
                        if(row.workState == 0) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-success">' + (self.workState[row.workState] || "") + '</span>  '
                        }
                        if(row.workState == 1) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-warning">' + (self.workState[row.workState] || "") + '</span>  '
                        }
                        if(row.workState == 2) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-danger">' + (self.workState[row.workState] || "") + '</span>  '
                        }
                        if(row.signinTime != null && row.signoutTime == null) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-success">已签到</span>  '
                        }
                        if(row.signoutTime != null) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-danger">已签退</span>  '
                        }
                        if(row.signinTime == null) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-danger">未签到</span>  '
                        }
                        if(row.servicerStaff.disabled) {
                            namecontent = namecontent + '<span class="swb-tags swb-tags-warning">禁用</span>  '
                        }
                        return namecontent;
                    },
                    'syncFlag': function (row, colName, colValue, rowIndex, colConf) {
                        let syncFlag = row.syncServcFlag || row.syncShopFlag ? "是" : "否";
                        //
                        return '<span>' + syncFlag + '</span>';
                    },
                }, /* 单元格按钮点击处理函数 */{
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getServicerXngineerList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServicerXngineerList();

            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getServicerXngineerList();
            },
            getServicerXngineerList: function () {
                let self = this;
                //
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.deleted = false;
                filterItems.disabled = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let loading = MsgBox.loading();
                servicerApi.getServicerXngineerList(postData, function (result) {
                    loading.close();
                    if(result.type === "info") {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows || [], pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let result = {};
                result.type = "info";
                //
                let servicerXngineerList = this.getTableSelection() || [];
                if(servicerXngineerList.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选择工程师';
                } else {
                    result.data = servicerXngineerList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerXngineerListForSelect.vue